<template>
    <div id="order-type-modal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Atenção</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                    </div>
                    <div class="row">
                        <div class="col-md-12" id="tpKombiOrder">
                            <FormHelper :inputVar="formOrderType.kombiType"
                                        :form="formOrderType"
                                        :options="kombiOptions()"
                                        style="text-align: center"
                                        type="radio"
                                        label="Qual tipo de Carrinho deseja criar para incluir esse produto?"></FormHelper>
                        </div>
                    </div>
                    <div id="cliente-list-modal">
                        <div class="row">
                            <div class="col-md-12">
                                <FormHelper :inputVar="formOrderType.cliente"
                                            :form="formOrderType"
                                            :options="formOrderType.clientes"
                                            type="select"
                                            label="Meu cliente cadastrado é:"
                                            :placeholder="formOrderType.status"></FormHelper>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                Cliente não consta na lista?
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                Cadastre <a class="btn btn-success" :href="`${$SiteUrl}/loja/minha-conta/cadastro-venda-direta`" style="padding: 2px">aqui</a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                Consulte por CNPJ/CPF <a class="btn btn-success" href="#" v-on:click.prevent="searchCliente" style="padding: 2px">aqui</a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12" style="font-size:10px;margin-top:10px;">
                                ATENÇÃO: Para recebimento da comissão, é necessário que sua empresa possua o CNAE correto e liberação de sua prefeitura para emissão de nota fiscal com um destes dois itens de serviço possíveis:
                                <br>
                                <strong>CNAE 73.19-002</strong> - PROMOÇÃO DE VENDAS (HABILITAR EM SUA PREFEITURA O <strong>ITEM DE SERVIÇO 17.06</strong>)
                                <br>
                                <strong>CNAE 46.18-499</strong> - OUTROS REPRESENTANTES COMERCIAIS E AGENTES DO COM ESPECIALIZ EM PRODUTOS NÃO ESPECIFIC ANTERIORMENTE (HABILITAR EM SUA PREFEITURA O <strong>ITEM DE SERVIÇO 10.09</strong>)
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button aria-label="Fechar" type="button" class="btn btn-default" data-dismiss="modal" v-on:click="closeModal">Fechar</button>
                    <button aria-label="Criar Carrinho" id="btn-kombi" type="button" class="btn btn-primary" v-on:click="createKombi">Criar Carrinho</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style type="text/css">
    div#tpKombiOrder label:nth-child(3) {
        color: #21026d;
        font-size: 16px;
        font-weight: bold;
    }
</style>
<script>
    import FormHelper from './FormHelper.vue'
    import CarrinhoService from '../../services/CarrinhoService';

    export default {
        name: 'OrderTypeModal',
        props: ['product', 'customProducts'],
        components: {
            FormHelper
        },
        data() {
            return {
                formOrderType: {
                    orderType: new this.$formInput(false, ""),
                    kombiType: new this.$formInput(false, ""),
                    cliente: new this.$formInput(false),
                    clientes: [],
                    status: "",
                }
            }
        },
        mounted() {
            jQuery("#cliente-list-modal").hide();
        },
        watch: {
            "formOrderType.kombiType.value": function (v) {
                var $cliList = jQuery("#cliente-list-modal");
                if (v == 100) {
                    this.formOrderType.status = "Carregando clientes...";
                    this.getClientes();
                    $cliList.show();
                } else {
                    this.formOrderType.cliente.value = null;
                    $cliList.hide();
                }
            }
        },
        methods: {
            updateCount() {
                this.$parent.updateCount()
            },
            typeOptions: function () {
                const types = [
                    { code: 1, label: "COMPRAR (Adicionar ao Carrinho)", value: "comprar" }
                ];
                return types;
            },
            kombiOptions: function () {
                const types = [
                    { code: 1, label: "Venda Normal", value: 10 },
                    { code: 2, label: "Venda Direta", value: 100 }
                ];
                return types;
            },
            getClientes: function () {
                this.formOrderType.clientes = [];
                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText);
                            json.forEach((element) => {
                                let item = {};
                                item.code = element.CliCodigo;
                                item.label = element.CliNomeadicional1;
                                this.formOrderType.clientes.push(item);
                            });
                            this.formOrderType.status = "Selecione um cliente";
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }
                xhr.open("POST", this.$apiUrl + "Cliente.svc/getclientesvendadireta");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({ listarFisicos: true, desabilitaClienteBloqueado: true }));
            },
            createKombi: function () {
                const self = this;
                let obj = {};
                obj.tipo_pedido = this.formOrderType.kombiType.value;
                obj.emp_filial = 1;
                if (obj.tipo_pedido == 100) {
                    if (this.formOrderType.cliente.value.code == undefined) {
                        swal({
                            title: "Selecione um cliente",
                            icon: "warning"
                        });
                        return;
                    }
                    else {
                        obj.digitador = this.formOrderType.cliente.value.code;
                    }
                } else if (obj.tipo_pedido == "") {
                    swal({
                        title: "Selecione um tipo de venda",
                        icon: "warning"
                    });
                    return;
                }

                const xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            if (!(/^\d+(?:\.\d+)?$/.test(xhr.responseText.replace(/[\\"]/g, '')))) {
                                swal({
                                    title: xhr.responseText.replace(/[\\"]/g, ''),
                                    icon: "warning"
                                });
                            }
                            else {
                                if (this.product) {
                                    this.addProduto(parseInt(JSON.parse(xhr.responseText)))
                                }else {
                                    this.addCustomProduct(parseInt(JSON.parse(xhr.responseText)))
                                }
                                self.$root.$children[0].getSession();
                                $('#order-type-modal').modal('hide');
                            }
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }
                xhr.open("POST", this.$apiUrl + "Carrinho.svc/CriarPedido");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    tipo_pedido: this.formOrderType.kombiType.value,
                    digitador: obj.digitador,
                    emp_filial: 1
                }));
            },
            createCotacao: function () {
                let obj = {};
                obj.tipo_pedido = this.formOrderType.kombiType.value;
                obj.emp_filial = 1;
                if (obj.tipo_pedido == 100) {
                    if (this.formOrderType.cliente.value.code == undefined) {
                        swal({
                            title: "Selecione um cliente",
                            icon: "warning"
                        });
                        return;
                    }
                    else {
                        obj.digitador = this.formOrderType.cliente.value.code;
                    }
                } else if (obj.tipo_pedido == "") {
                    swal({
                        title: "Selecione um tipo de venda",
                        icon: "warning"
                    });
                    return;
                }

                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            if (!(/^\d+(?:\.\d+)?$/.test(xhr.responseText.replace(/[\\"]/g, '')))) {
                                swal({
                                    title: xhr.responseText.replace(/[\\"]/g, ''),
                                    icon: "warning"
                                });
                            }
                            else {
                                this.addProduto(parseInt(JSON.parse(xhr.responseText)))
                                $('#order-type-modal').modal('hide');
                            }
                        }
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }

                xhr.open("POST", this.$apiUrl + "Carrinho.svc/CriarOrcamento");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    tipo_pedido: this.formOrderType.kombiType.value,
                    digitador: obj.digitador,
                    emp_filial: 1
                }));

            },
            searchCliente: function () {
                this.fixBootstrapModal();
                swal({
                    text: "Informe um CNPJ/CPF",
                    content: {
                        element: 'input',
                        attributes: {
                            placeholder: 'Digite o CNPJ/CPF'
                        }
                    },
                    button: {
                        text: "Buscar",
                        closeModal: false,
                    },
                }).then(documento => {
                    if (documento != "" && documento != null) {
                        const xhr = new XMLHttpRequest();
                        xhr.onload = () => {
                            if (xhr.status == 200) {
                                let element = JSON.parse(xhr.responseText);
                                let item = {};
                                item.code = element.CliCodigo;
                                item.label = element.CliNomeadicional1;

                                this.formOrderType.cliente.value = item;
                                this.formOrderType.status = "";
                                this.restoreBootstrapModal();
                                swal.stopLoading();
                                swal.close();
                            }
                            else if (xhr.status == 404) {
                                swal({
                                    title: "CPF/CNPJ não encontrado",
                                    icon: "warning"
                                });
                            }
                        }

                        xhr.open("POST", this.$apiUrl + "Cliente.svc/getclientebusca");
                        xhr.setRequestHeader("Content-Type", "application/json");
                        xhr.withCredentials = true;
                        xhr.send(JSON.stringify({ cnpj: documento, listarFisicos: true }));
                    }
                    else {
                        swal({
                            title: "Preencha o campo",
                            icon: "warning"
                        });
                    }
                    this.restoreBootstrapModal();
                }).catch(err => {
                    this.restoreBootstrapModal();
                });
            },
            //métodos para poder usar o swal input em modal
            fixBootstrapModal: function () {
                let modalNode = document.querySelector('#order-type-modal[tabindex="-1"]');
                if (!modalNode) return;

                modalNode.removeAttribute('tabindex');
                modalNode.classList.add('js-swal-fixed');
            },
            restoreBootstrapModal: function () {
                let modalNode = document.querySelector('.modal.js-swal-fixed');
                if (!modalNode) return;

                modalNode.setAttribute('tabindex', '-1');
                modalNode.classList.remove('js-swal-fixed');
            },
            addProduto: function (codigoParametro) {
                const xhr = new XMLHttpRequest();
                const data = JSON.stringify(
                    {
                        codigoPedido: codigoParametro,
                        prd_codigo: this.product.code.split('-')[0],
                        produtoDv: this.product.code.split('-')[1],
                        qtde: parseInt(this.product.qtd)
                    }
                );

                xhr.open("post", this.$apiUrl + 'Carrinho.svc/AdicionarProdutoAjax');
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(data);
                xhr.onload = () => {
                    if (JSON.parse(xhr.responseText)[0] == "AVISO") {
                        let span = document.createElement("span")
                        span.innerHTML = JSON.parse(xhr.responseText)[1]

                        swal({
                            content: span,
                            icon: "warning"
                        });
                    }
                    else {
                        swal({
                        title: 'Produto adicionado com sucesso!',
                        buttons: ['Continuar a compra', 'Ir para o carrinho'],
                        }).then((goCar) => {
                        if (goCar) {
                            this.openCart();
                        }
                        });
                    }
                }
            },
            addCustomProduct: async function(codigoParametro) {
                // ao ajustar aqui, não esquecer de modificar tbm no arquivo de Resume.vue
                const products = this.customProducts.map((f) => {
                    const insumos = CarrinhoService.NormalizarInsumos(f.Insumos)
                    return {
                        Codigo: f.Codigo,
                        Descricao: f.Descricao,
                        Insumos: insumos,
                        Quantidade: f.qtde,
                        Preco: f.valor,
                    }
                })

                try {
                    const data = {
                        codigoPedido: codigoParametro,
                        produtos: products,
                    }

                    const response = await CarrinhoService.AddCustomProduct(this.$apiUrl, data)

                    if (response.filter((f) => f !== 'sucesso').length > 0) {
                        let span = document.createElement('span')
                        span.style.textAlign = 'left'
                        span.innerHTML = response.map((f) => {
                            return `- ${f}<br />`
                        })

                        swal({
                            content: span,
                            icon: 'warning',
                        })
                    } else {
                        this.updateCount()
                        swal({
                        title: 'Produto adicionado com sucesso!',
                        buttons: ['Continuar a compra', 'Ir para o carrinho'],
                        }).then((goCar) => {
                        if (goCar) {
                            this.openCart();
                        }
                        });

                        this.$emit('clear')
                    }
                } catch (error) {
                    swal({
                        title: 'Ocorreu um erro desconhecido!',
                        icon: 'error',
                    })
                    this.$parent.carregando = false
                }
            },
            openCart: function(){
                const self = this
                var isVendaDireta = localStorage.getItem('GetTipoPedido').includes('DIRETA')

                if (isVendaDireta) {
                        location.href = `${self.$SiteUrl}/loja/meu-carrinho-venda-direta/carrinho`;
                }
                else {location.href = `${self.$SiteUrl}/loja/meu-carrinho/carrinho`;
                }
            },
            closeModal(){
                if (!this.product) {
                    this.$parent.carregando = false
                }
            }
        }
    }
</script>
